import React from 'react';
import PropTypes from 'prop-types';
import ValidatedComponent from '../common/ValidatedComponent.jsx';
import InputValidator from '../common/InputValidator.jsx';
import Modal from 'react-modal';

const customStyles = {
  overlay: {
    zIndex: '999999'
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '5px 10px',
    maxHeight: '86%',
    transform: 'translate(-50%, -50%)',
    background: '#f2f2f2'
  }
};

class SocialAuthEmailPopup extends React.Component {
  constructor() {
    super();

    this.state = {
      email: '',
      isOpen: true
    };
  }

  render() {
    const {email, isOpen} = this.state;
    return (
      <div>
        <Modal isOpen={isOpen}
               onRequestClose={() => this.setState({isOpen: false})}
               style={customStyles}>
          <h4>Please provide an email address for your account:</h4>
          <InputValidator fieldName="Email">
            <input type="email"
                   required
                   value={email}
                   onChange={(e) => {
                     this.setState({email: e.target.value});
                   }}
                   placeholder="Account Email*"/>
          </InputValidator>
          <button onClick={this.sendEmail.bind(this)}>Submit</button>
        </Modal>
      </div>
    );
  }

  sendEmail() {
    if (this.context.isComponentValid()) {
      this.props.onSendAuthEmail(this.state.email);
    }
  }
}

SocialAuthEmailPopup.propTypes = {
  onSendAuthEmail: PropTypes.func.isRequired
};

export default ValidatedComponent(SocialAuthEmailPopup);



// WEBPACK FOOTER //
// ./shared/auth/SocialAuthEmailPopup.jsx